import { BOLD_KEY } from '@techchange/pm-specs';
import { toggleMark } from 'prosemirror-commands';

/**
 * Toggles the bold mark.
 *
 * @param {Object} state     The current editor state.
 * @param {Object} dispatch  The editor dispatch.
 *
 * @returns {boolean} Whether or not the command was successful.
 *
 */
export const toggleStrong = (state, dispatch) => {

	const strongMarkType = state.schema.marks[BOLD_KEY];

	return toggleMark(strongMarkType)(state, dispatch);

};
